<template>
  <div class="swiper">
    <el-carousel :interval="5000" indicator-position='none' :height='boxHeight' arrow="always">

      <el-carousel-item>
        <img class="swiper_img" src="@/assets/img/swiper/banner1.png" alt="">
      </el-carousel-item>

      <!-- <el-carousel-item>
        <img class="swiper_img" src="@/assets/img/swiper/banner2.png" alt="">
      </el-carousel-item>

      <el-carousel-item>
        <img class="swiper_img" src="@/assets/img/swiper/banner2.png" alt="">
      </el-carousel-item> -->

    </el-carousel>

  </div>
</template>

<script>
export default {
  name: "Swiper",
  props: {
    boxHeight: {
      type: String,
      default: "120px"
    }
  }
};
</script>

<style lang='less' scoped>
.swiper_img {
  width: 100%;
  height: 100%;
}

/deep/.el-carousel__arrow--left {
  left: 360px;
}

/deep/.el-carousel__arrow--right {
  right: 360px;
}
</style>